import { nanoid } from 'nanoid'
import { type ActionItem } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { Content } from 'pages/chatbot/pages/calling/actions/details/Content'

export const details = (item: ICallingListResponse): ActionItem => {
  return {
    text: 'Details',
    icon: 'eye',
    onAction: () => {
      modalStore.addModal({
        id: nanoid(),
        width: 540,
        position: 'right',
        type: ModalTypeList.DEFAULT,
        ModalContent: () => <Content item={item} />,
        title: 'Details',
        pureContent: true,
        fullHeight: true,
        autoOverflow: true,
      })
    },
  }
}
